import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { normalizeAgentMarkdown } from '../../lib/agentMarkdown';

export function AgentMarkdown({ text }: { text: string }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]}>
      {normalizeAgentMarkdown(text)}
    </ReactMarkdown>
  );
}
